<template>
  <div class="page_box">
    <div class="page_option_box">
      <!-- 监控列表 -->
      <el-page-header
        @back="$Common.pageJump('/broadcastController', 3)"
        content="分区设备管理"
      >
      </el-page-header>
      <el-button
        type="primary"
        size="mini"
        plain
        icon="el-icon-circle-plus-outline"
        @click="showDialog = true"
        >新增分区设备</el-button
      >
    </div>
    <div class="page_table_box">
      <div class="school_table_box" style="height:100%">
        <el-table
          :data="responseData.list"
          tooltip-effect="dark"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
        >
          <el-table-column
            type="index"
            label="序号"
            width="70"
            align="center"
          ></el-table-column>
          <el-table-column prop="parName" label="分区设备名称" align="center">
          </el-table-column>
          <el-table-column prop="parNumber" label="分区设备编号" align="center">
          </el-table-column>
          <el-table-column prop="powerSupply" label="所属电源" align="center">
          </el-table-column>
          <el-table-column label="操作" width="180px">
            <template slot-scope="rowData">
              <el-link
                type="primary"
                @click="openBox(rowData.row)"
                :underline="false"
                >编辑</el-link
              >
              <el-divider direction="vertical"></el-divider>
              <el-link
                type="primary"
                @click="delData(rowData.row.id)"
                :underline="false"
                >删除</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 新增/编辑分区设备 -->
      <el-dialog
        :before-close="cancelForm"
        :visible.sync="showDialog"
        direction="ltr"
        custom-class="demo-drawer"
        ref="drawer"
         width="800px"
        append-to-body
        size="30%"
        :wrapperClosable="false"
        :close-on-press-escape="false"
      >
        <div class="demo-drawer__content ">
          <form class="form-horizontal form_box">
            <div class="form-group">
              <label class="col-sm-3 control-label">分区设备名称</label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="insertData.parName"
                  placeholder="请输入分区设备名称"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-3 control-label">分区设备编号</label>
              <div class="col-sm-9">
                <el-select
                  v-model="insertData.parNumber"
                  placeholder="请选择分区设备编号"
                  size="small"
                  style="width:100%"
                >
                  <el-option
                    v-for="(item, index) in parNumberArray"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-3 control-label">所属电源</label>
              <div class="col-sm-9">
                <el-select
                  v-model="insertData.powerSupply"
                  placeholder="请选择所属电源"
                  size="small"
                  style="width:100%"
                >
                  <el-option
                    v-for="(item, index) in powerSupplyArray"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="form-group">
              <label for="inputEmail3" class="col-sm-2 control-label"></label>
              <div class="col-sm-10">
                <el-button
                  size="mini"
                  type="primary"
                  @click="operateBroadcastControllerArea()"
                  >确定添加</el-button
                >
                <el-button size="mini" @click="cancelForm">返回</el-button>
              </div>
            </div>
          </form>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import CampusBroadcastSettings from "@/components/CampusBroadcastSettings";
export default {
  name: "",
  components: { CampusBroadcastSettings },
  props: {},
  data() {
    return {
      showDialog: false,
      parNumberArray: [
        {
          value: "",
          label: "请选择分区设备编号"
        },
        {
          value: 1,
          label: "1号设备"
        },
        {
          value: 2,
          label: "2号设备"
        },
        {
          value: 3,
          label: "3号设备"
        },
        {
          value: 4,
          label: "4号设备"
        },
        {
          value: 5,
          label: "5号设备"
        },
        {
          value: 6,
          label: "6号设备"
        },
        {
          value: 7,
          label: "7号设备"
        },
        {
          value: 8,
          label: "8号设备"
        },
        {
          value: 9,
          label: "9号设备"
        },
        {
          value: 10,
          label: "10号设备"
        },
        {
          value: 11,
          label: "11号设备"
        },
        {
          value: 12,
          label: "12号设备"
        },
        {
          value: 13,
          label: "13号设备"
        },
        {
          value: 14,
          label: "14号设备"
        },
        {
          value: 15,
          label: "15号设备"
        },
        {
          value: 16,
          label: "16号设备"
        }
      ],
      powerSupplyArray: [
        {
          value: "",
          label: "请选择所属电源"
        },
        {
          value: 1,
          label: "1号电源"
        },
        {
          value: 2,
          label: "2号电源"
        },
        {
          value: 3,
          label: "3号电源"
        },
        {
          value: 4,
          label: "4号电源"
        },
        {
          value: 5,
          label: "5号电源"
        },
        {
          value: 6,
          label: "6号电源"
        },
        {
          value: 7,
          label: "7号电源"
        },
        {
          value: 8,
          label: "8号电源"
        }
      ],
      // 响应数据
      responseData: {
        pageSize: 0,
        pageNum: 0,
        total: 0,
        pages: 0,
        list: []
      },
      insertData: {
        id: "",
        parName: "",
        parNumber: "",
        powerSupply: "",
        conrId: "",
        schoolId: this.$store.state.schoolId
      }
    };
  },
  created() {
    let broadcastConrId = this.$store.state.broadcastConrId;
    this.insertData.conrId = broadcastConrId;
    this.getBroadcastControllerArea();
  },
  mounted() {},
  watch: {},
  computed: {},
  methods: {
    clearData() {
      this.insertData.id = "";
      this.insertData.parName = "";
      this.insertData.parNumber = "";
      this.insertData.powerSupply = "";
    },
    openBox(thisData) {
      this.insertData.id = thisData.id;
      this.insertData.parName = thisData.parName;
      this.insertData.parNumber = thisData.parNumber;
      this.insertData.powerSupply = thisData.powerSupply;
      this.showDialog = true;
    },
    // 新增 / 编辑 广播控制器下广播分区
    async operateBroadcastControllerArea() {
      if (this.insertData.parName == "") {
        this.$message("请输入分区设备名称!");
        return;
      }
      if (this.insertData.parNumber == "") {
        this.$message("请选择分区设备编号!");
        return;
      }
      if (this.insertData.powerSupply == "") {
        this.$message("请选择所属电源!");
        return;
      }
      let req = this.insertData;
      let res = await this.$Http.operateBroadcastControllerArea(req, true);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.messsage
        });
        this.showDialog = false;
        this.clearData();
        this.getBroadcastControllerArea();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },

    // 获取广播控制器下广播分区
    async getBroadcastControllerArea() {
      var req = {
        conrId: this.insertData.conrId
      };
      let res = await this.$Http.getBroadcastControllerArea(req);
      if (res.code == 200) {
        // console.log(res)
        this.responseData.pageSize = res.data.pageSize || 20;
        this.responseData.pageNum = res.data.pageNum || 0;
        this.responseData.total = res.data.total || 0;
        this.responseData.pages = res.data.pages || 0;
        this.responseData.list = res.data || [];
      } else if (res.code == 101) {
        this.responseData.list = [];
        this.responseData.total = 0;
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },

    // 删除数据
    delData(dataId) {
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let req = {
            ids: [dataId]
          };
          // console.log(req)
          // return;
          let res = await this.$Http.delBroadcastControllerArea(req, true);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getBroadcastControllerArea();
          } else if (res.code == 101) {
          } else {
            this.$message({
              type: "error",
              message: res.messsage
            });
          }
        })
        .catch(() => {});
    },
    cancelForm() {
      this.clearData();
      this.showDialog = false;
    }
  }
};
</script>
<style scoped></style>
